import CircleIcon from '@mui/icons-material/Circle'
import { Box, Grid, Typography } from '@mui/material'
import DeviceDetailCard from './DeviceDetailCard'

export default function DetailHeader({
    data,
    handleAlert,
    user,
    deviceDetail,
    color,
}) {
    return (
        <Grid
            container
            gap={2}
            display={'flex'}
            justifyContent={'space-between'}
            flexDirection={{ xs: 'column', md: 'row' }}
        >
            <Grid
                item
                xs={12}
                md={6.6}
                sx={{ border: '2px solid #B1B2B2', borderRadius: 3, p: 1 }}
            >
                <DeviceDetailCard
                    user={user}
                    data={data}
                    handleAlert={handleAlert}
                />
            </Grid>
            <Grid
                item
                xs={12}
                md={5}
                sx={{
                    border: '2px solid #B1B2B2',
                    borderRadius: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                flexDirection={'column'}
                p={1}
                gap={2}
            >
                <Typography variant='h6'>Real-Time Status</Typography>
                <Box
                    sx={{
                        borderRadius: 50,
                        border: '2px solid #B1B2B2',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircleIcon
                        sx={{
                            fontSize: 150,
                            color:
                                deviceDetail?.status === 'Offline'
                                    ? 'gray'
                                    : deviceDetail?.status === 'Online' &&
                                      !deviceDetail.type_alert
                                    ? '#4CAF50'
                                    : color,
                        }}
                    />
                </Box>
            </Grid>
        </Grid>
    )
}
